import styled from 'styled-components'
import { UPLOAD_BUTTON_LABEL } from '../../constants'
import { TextSmall } from '../typography'

const StyledText = styled(TextSmall)`
    text-align: center;
    font-size: 13px;
    color: #a6a6a6;
    margin-left: auto;
    margin-right: auto;

    a {
        color: #d8d8d8;
        text-decoration: underline;
    }
`

const CreationUploadTerms = () => (
    <StyledText>
        By clicking &quot;{UPLOAD_BUTTON_LABEL}&quot; you agree to our{' '}
        <a href="/terms" target="_blank" rel="noopener noreferrer">
            Terms of Service
        </a>
        ,{' '}
        <a href="/community-guidelines" target="_blank" rel="noopener noreferrer">
            Community Guidelines
        </a>
        , and our{' '}
        <a href="/privacy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
        </a>
        .
    </StyledText>
)

export default CreationUploadTerms
